import { Injectable } from '@angular/core';

export interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private readonly CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutes

  isValid<T>(cache: Map<string, CacheEntry<T>>, cacheKey: string): boolean {
    const cached = cache.get(cacheKey);
    if (!cached) return false;
    const isExpired = Date.now() - cached.timestamp > this.CACHE_DURATION_MS;
    return !isExpired;
  }

  set<T>(cache: Map<string, CacheEntry<T>>, cacheKey: string, data: T): void {
    cache.set(cacheKey, { data, timestamp: Date.now() });
  }

  get<T>(cache: Map<string, CacheEntry<T>>, cacheKey: string): T | undefined {
    return cache.get(cacheKey)?.data;
  }

  clear<T>(cache: Map<string, CacheEntry<T>>): void {
    cache.clear();
  }

  delete<T>(cache: Map<string, CacheEntry<T>>, cacheKey: string): void {
    cache.delete(cacheKey);
  }
}
